import React from 'react';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { LOGIN } from '../constants/routes';

/**
 * Guards the signed-in area. A visitor who opens a dashboard URL without a
 * session is sent to the login page, and back to that URL once they sign in.
 */
const RequireAuth = () => {
    const isLoggedIn = useSelector((state) => get(state, 'auth.isLoggedIn'));
    const location = useLocation();

    if (!isLoggedIn) {
        return <Navigate to={LOGIN} replace state={{ from: location.pathname + location.search }} />;
    }

    return <Outlet />;
};

export default RequireAuth;
